import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function Unsubscribe() {
  const [sp] = useSearchParams();
  const [state, setState] = useState("working");

  useEffect(() => {
    api.post("/email/unsubscribe", { e: sp.get("e") || "", t: sp.get("t") || "" })
      .then(() => setState("done")).catch(() => setState("bad"));
  }, [sp]);

  return (
    <div className="max-w-md mx-auto px-6 pt-16 text-center" data-testid="unsubscribe-page">
      {state === "working" && <p className="text-gray-400">One sec...</p>}
      {state === "done" && (
        <>
          <h1 className="font-display text-3xl font-black" data-testid="unsubscribe-done">You're unsubscribed.</h1>
          <p className="mt-3 text-gray-300">You won't get any more tips or updates from us. Your account still works, and sign-in codes or password resets still arrive if you ask for them.</p>
        </>
      )}
      {state === "bad" && <p className="text-gray-300" data-testid="unsubscribe-bad">This unsubscribe link isn't valid. Email info@ihatemyjob.app and we'll take you off the list.</p>}
      <Link to="/" className="mt-6 inline-block underline text-gray-400">Back to ihatemyjob.app</Link>
    </div>
  );
}
